import { DepositDetailsType } from '@finxone-platform/shared/sys-config-types';
import { DepositAccountInfoStateModel } from '../state/deposit-account-info.state';

export class SetDepositAccountInfo {
  static readonly type = '[DepositAccountInfo] SetDepositAccountInfo';
  constructor(public state: DepositAccountInfoStateModel) {}
}

export class GetDepositAccountInfo {
  static readonly type = '[DepositAccountInfo] GetDepositAccountInfo';
  constructor(
    public type: DepositDetailsType[] = [
      DepositDetailsType.DEPOSIT_DETAILS,
      // add more status types, if needed...
    ],
  ) {}
}
